// Category definitions for the incident color coding.
// Order here is also the stack order, bottom to top.
export const CATEGORIES = [
  {
    key: 'brown',
    label: 'Football and homecoming',
    color: '#9C5B3C',
    toggleable: true,
  },
  {
    key: 'orange',
    label: 'Basketball',
    color: '#F18851',
    toggleable: true,
  },
  {
    key: 'gray',
    label: 'All other shootings',
    color: '#BFBFBF',
    toggleable: false,
  },

];

export const STACK_ORDER = CATEGORIES.map(c => c.key);

export function colorFor(key) {
  const cat = CATEGORIES.find(c => c.key === key);
  return cat ? cat.color : '#BFBFBF';
}
